import React, { useState } from 'react';
import { Modal, View, Text, TouchableOpacity, TextInput, StyleSheet, Linking, Platform } from 'react-native';
import { apiUrl } from './utils/config';

const FeedbackModal = ({ visible, onClose, sessionId }: { visible: boolean; onClose: () => void; sessionId: string }) => {
  const [step, setStep] = useState<'initial' | 'positiveFollowUp' | 'negative'>('initial');
  const [feedbackText, setFeedbackText] = useState('');

  const isMobile = Platform.OS === 'ios' || Platform.OS === 'android';

  const submitFeedback = async () => {
    try {
      const payload = {
        type: 'feedback',
        message: `SESSION: ${sessionId}\n\n${feedbackText}`,
      };
      await fetch(`${apiUrl}user/contact-us`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      onClose();
      setFeedbackText('');
      setStep('initial');
    } catch (err) {
      console.error('Feedback submit error:', err);
    }
  };

  const openReviewLink = () => {
    const appleLink = 'https://apps.apple.com/us/app/interactive-bedtime-story-ai/id6740042769';
    const androidLink = 'https://play.google.com/store/apps/details?id=com.interactivebedtime.stories';

    if (Platform.OS === 'ios') {
      Linking.openURL(appleLink);
    } else if (Platform.OS === 'android') {
      Linking.openURL(androidLink);
    } else {
      alert('Thanks! Reviews are only supported in the mobile app.');
    }
    onClose();
  };

  if (!isMobile || !visible) return null;

  return (
    <Modal visible={visible} transparent animationType="fade">
      <View style={styles.overlay}>
        <View style={styles.box}>
          {step === 'initial' && (
            <>
              <Text style={styles.title}>How are you enjoying your Interactive Bedtime experience?</Text>
              <View style={styles.buttonRow}>
                <TouchableOpacity onPress={() => setStep('positiveFollowUp')} style={styles.roundedButton}>
                  <Text style={styles.buttonText}>It's great!</Text>
                </TouchableOpacity>
                <TouchableOpacity onPress={() => setStep('negative')} style={styles.roundedButton}>
                  <Text style={styles.buttonText}>Could be better</Text>
                </TouchableOpacity>
              </View>
            </>
          )}

          {step === 'positiveFollowUp' && (
            <>
              <Text style={styles.title}>Thanks for your feedback! Would you like to leave us a review?</Text>
              <View style={styles.buttonRow}>
                <TouchableOpacity onPress={openReviewLink} style={styles.roundedButton}>
                  <Text style={styles.buttonText}>Leave Review</Text>
                </TouchableOpacity>
                <TouchableOpacity onPress={onClose} style={styles.roundedButton}>
                  <Text style={styles.buttonText}>Not Right Now</Text>
                </TouchableOpacity>
              </View>
            </>
          )}

          {step === 'negative' && (
            <>
              <Text style={styles.title}>How can we do better?</Text>
              <TextInput
                style={styles.input}
                multiline
                placeholder="Your feedback..."
                value={feedbackText}
                onChangeText={setFeedbackText}
              />
              <TouchableOpacity onPress={submitFeedback} style={styles.submitButton}>
                <Text style={styles.buttonText}>Submit</Text>
              </TouchableOpacity>
            </>
          )}
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.6)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  box: {
    backgroundColor: 'white',
    padding: 20,
    borderRadius: 16,
    width: '85%',
    maxWidth: 400,
  },
  title: {
    fontSize: 18,
    marginBottom: 20,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  buttonRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 10,
  },
  roundedButton: {
    backgroundColor: '#544564',
    paddingVertical: 12,
    paddingHorizontal: 20,
    borderRadius: 20,
    flex: 1,
    justifyContent: 'center',  // ⬅️ Vertically center text
    alignItems: 'center',      // ⬅️ Horizontally center text
  },
  buttonText: {
    color: 'white',
    textAlign: 'center',
    fontSize: 16,
  },
  input: {
    borderColor: '#ccc',
    borderWidth: 1,
    borderRadius: 8,
    padding: 10,
    minHeight: 80,
    textAlignVertical: 'top',
  },
  submitButton: {
    backgroundColor: '#544564',
    padding: 12,
    borderRadius: 10,
    marginTop: 10,
    justifyContent: 'center',  // ⬅️ Vertically center text
    alignItems: 'center',      // ⬅️ Horizontally center text
  },
});

export default FeedbackModal;
